import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { setBreadCrumbs } from '../../actions/breadcrumbs'

require('./mxprepareexperiment.css')

class MXStepContainer extends React.Component {
  render() {
    return (
      <div className="steps-container">
        <div className="container">
          <div className="row">
            <div className="stepwizard">
              <div className="stepwizard-row">
                <div className="stepwizard-step">
                  <a
                    id="step-1"
                    className={`${
                      this.props.step === 1
                        ? 'btn btn-circle step-btn active-step'
                        : 'btn btn-default btn-circle step-btn '
                    }`}
                  >
                    1
                  </a>
                  <p>Select Shipment</p>
                </div>
                <div className="stepwizard-step">
                  <a
                    id="step-2"
                    className={`${
                      this.props.step === 2
                        ? 'btn btn-circle step-btn active-step'
                        : 'btn btn-default btn-circle step-btn '
                    }`}
                  >
                    2
                  </a>
                  <p>Load Sample Changer</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    application: state.application,
    user: state.user,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setBreadCrumbs: breadCrumbs => dispatch(setBreadCrumbs(breadCrumbs)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MXStepContainer)

MXStepContainer.propTypes = {
  step: PropTypes.number,
}
